import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useTextEnableLandlineContext } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/TextEnableLandline/context/useTextEnableLandlineContext'
import { InboxCommonPayment } from 'pages/settings/ui/InboxCommonPayment/InboxCommonPayment'

export const Payment = observer(() => {
  const { paymentStore, buyNumber, loading, phone, setVisibleUI, selectedNumbersCount } =
    useTextEnableLandlineContext()

  useEffect(() => {
    setVisibleUI(true)

    return () => {
      setVisibleUI(false)
    }
  }, [])

  return (
    <InboxCommonPayment
      textEnableLandlinePhone={phone}
      salesmsgNumbers={[]}
      licensesRequired={selectedNumbersCount}
      stepLoading={loading}
      paymentStore={paymentStore}
      handleOnClick={() => buyNumber()}
      buttonText={'Buy number'}
    />
  )
})
